import { SxStyles } from '../../../../../../../types';
import theme from '../../../../../../../theme';
import { getResponsiveSize } from '../../../../../../../utils';

export const VideoUploadStyle: SxStyles = {
  videoTabContainer: {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    alignItems: 'center',

    '& .video-container': {
      pt: `calc(${theme.palette.propVars?.index} * 0.555)`,
      width: '100%',
      height: '100%',

      '& video': {
        borderRadius: theme.palette.propVars?.borderRadius,
      },
      '& .video-default': {
        height: '100%',

        '& img': {
          height: getResponsiveSize(152),
          width: getResponsiveSize(152),
          objectFit: 'cover',
          borderRadius: theme.palette.propVars?.borderRadius,
          margin: 'auto',
        },
      },
    },
  },
};
